// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__RSyhg","iconWithCounter":"styles_iconWithCounter__uoBY1","counterForLabel":"styles_counterForLabel__Uc7Vj","counterForIcon":"styles_counterForIcon__n9XuM"};